import { createAction } from 'redux-act';

const toggleSidebar = createAction('GET_MINIMIZE_SIDEBAR', data => data);

const handleClearCommonStore = createAction(
  'HANDLE_CLEAR_COMMON_STORE',
  data => data,
);
const handleMessageNotificationRequest = createAction(
  'HANDLE_MESSAGE_NOTIFICATION_REQUEST',
  data => data,
);
const handleMessageNotificationSuccess = createAction(
  'HANDLE_MESSAGE_NOTIFICATION_SUCCESS',
  data => data,
);

const handleToastMessage = createAction(
  'HANDLE_TOAST_MESSAGE',
  data => data,
);

/* Get App Constant Data */
const getAppConstantDataRequest = createAction('GET_APP_CONSTANT_DATA_REQUEST', data => data);
const getAppConstantDataSuccess = createAction('GET_APP_CONSTANT_DATA_SUCCESS', data => data);
const getAppConstantDataError = createAction('GET_APP_CONSTANT_DATA_ERROR');

/* Get Date Constant Data */
const getDateConstantRequest = createAction('GET_DATE_CONSTANT_REQUEST', data => data);
const getDateConstantSuccess = createAction('GET_DATE_CONSTANT_SUCCESS', data => data);
const getDateConstantError = createAction('GET_DATE_CONSTANT_ERROR');

// clear existing data for constant
const handleClearGetDateConstantStore = createAction('HANDLE_CLEAR_GET_DATE_CONSTANT_STORE', data => data);

/* Get  Constant By Category Subcategory Data */
const getConstantByCategorySubcategoryRequest = createAction('GET_CONSTANT_BY_CATEGORY_SUBCATEGORY_REQUEST', data => data);
const getConstantByCategorySubcategorySuccess = createAction('GET_CONSTANT_BY_CATEGORY_SUBCATEGORY_SUCCESS', data => data);
const getConstantByCategorySubcategoryError = createAction('GET_CONSTANT_BY_CATEGORY_SUBCATEGORY_ERROR');

/* Get  Constant By Category Subcategory Data */
const checkInCheckOutMachineRequest = createAction('CHECK_IN_CHECK_OUT_MACHINE_REQUEST', data => data);
const checkInCheckOutMachineSuccess = createAction('CHECK_IN_CHECK_OUT_MACHINE_SUCCESS', data => data);
const checkInCheckOutMachineError = createAction('CHECK_IN_CHECK_OUT_MACHINE_ERROR');

export default {
  toggleSidebar,
  handleClearCommonStore,
  handleMessageNotificationRequest,
  handleMessageNotificationSuccess,
  handleToastMessage,

  getAppConstantDataRequest,
  getAppConstantDataSuccess,
  getAppConstantDataError,

  getDateConstantRequest,
  getDateConstantSuccess,
  getDateConstantError,

  handleClearGetDateConstantStore,
  getConstantByCategorySubcategoryRequest,
  getConstantByCategorySubcategorySuccess,
  getConstantByCategorySubcategoryError,

  checkInCheckOutMachineRequest,
  checkInCheckOutMachineSuccess,
  checkInCheckOutMachineError,
};
